import React, { useEffect, useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useHistory, useParams } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import ResetPasswordDialog from "../customers/ResetPasswordDialog";
import { GATED_SHIFT_ROLES } from "../../services/shiftService";
import styles from "./staffMember.module.scss";

const STAFF_ROLES = [...GATED_SHIFT_ROLES, "admin"];
const ROLE_LABELS = { clerk: "Clerk", handler: "Handler", airportStaff: "Airport Staff", driver: "Driver", admin: "Admin" };

function StaffMember() {
    const breadItems = [{ label: "Home", url: "/" }, { label: "Staff", url: "/staff" }, { label: "Staff Member" }];
    const home = { icon: "pi pi-home", url: "/" };
    const [memberData, setMemberData] = useState();
    const [showDialog, setShowDialog] = useState(false);
    const [email, setEmail] = useState("");
    const history = useHistory();
    const { id } = useParams();
    const [role, setRole] = useState("");

    const getDetails = async () => {
        const res = await handleGetRequest(`/getuser/${id}`);
        const keyData = res?.data;
        setEmail(res?.data?.email);
        setMemberData(keyData);
        setRole(res?.data?.role);
        Object.keys(keyData || {}).forEach((key) => {
            if (formik.initialValues.hasOwnProperty(key)) {
                formik.setFieldValue(key, keyData[key]);
            }
        });
    };
    useEffect(() => {
        getDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            notes: memberData?.notes ?? "",
        },

        onSubmit: async (data) => {
            data._id = id;
            data.role = role;
            const result = await handlePutRequest(data, "/Edituser");
            if (result?.success) {
                getDetails();
                toast.success("Staff member updated");
            }
        },
    });

    const handleCancel = () => {
        history.push("/staff");
    };

    const onsuccess = () => {
        setShowDialog(false);
        toast.success("Password reset successfully.");
    };

    return (
        <div className={styles.staffMemberPage}>
            <Dialog visible={showDialog} header="Reset Password" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <ResetPasswordDialog onHideTyreBrandsDialog={() => setShowDialog(false)} onsuccess={onsuccess} email={email} />
            </Dialog>

            <div className={styles.pageHeader}>
                <div>
                    <h2>
                        {memberData?.firstName} {memberData?.lastName}
                    </h2>
                    <BreadCrumb model={breadItems} home={home} />
                </div>
                <Button label="Reset Password" icon="pi pi-key" iconPos="right" onClick={() => setShowDialog(true)} className={styles.resetButton} />
            </div>

            <form onSubmit={formik.handleSubmit}>
                <div className={styles.cardsGrid}>
                    <div className={styles.sectionCard}>
                        <h3>Personal Information</h3>
                        <div className={styles.field}>
                            <label htmlFor="firstName">First Name</label>
                            <InputText id="firstName" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="lastName">Last Name</label>
                            <InputText id="lastName" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="email">Email Address</label>
                            <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="phone">Phone Number</label>
                            <InputText id="phone" name="phone" value={formik.values.phone} onChange={formik.handleChange} />
                        </div>
                    </div>

                    <div className={styles.sectionCard}>
                        <h3>Role</h3>
                        <div className={styles.field}>
                            <label htmlFor="role">Staff Role</label>
                            <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
                                <option disabled value="">
                                    Select Role
                                </option>
                                {STAFF_ROLES.map((r) => (
                                    <option key={r} value={r}>
                                        {ROLE_LABELS[r] || r}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className={`${styles.sectionCard} ${styles.fullWidthCard}`}>
                        <h3>Notes</h3>
                        <div className={styles.field}>
                            <InputTextarea id="notes" name="notes" value={formik.values.notes} onChange={formik.handleChange} rows={5} placeholder="Add any additional notes here..." />
                        </div>
                    </div>
                </div>

                <div className={styles.actionsFooter}>
                    <Button type="button" label="Cancel" className={styles.cancelButton} onClick={handleCancel} />
                    <Button type="submit" label="Update" className={styles.saveButton} />
                </div>
            </form>
        </div>
    );
}

export default StaffMember;
